import { Injectable } from '@angular/core';
import { ProviderParking, ProviderParkingDto } from '../../models/provider-parking/provider-parking.model';

@Injectable({
    providedIn: 'root',
})
export class MapperProviderParkingService {
    
    constructor() { }

    /** 
     * Map Data From API (DTO) to Logical Model (ProviderParking) 
     */
    public mapProviderParkingFromDto(dto: ProviderParkingDto): ProviderParking {
        return {
            id: dto.Id || 0,
            name: dto.ProviderName || '',
            address: dto.Address || '',
            phoneNumber: dto.Phone || '',
            taxId: dto.TaxNumber || '',
            branch: dto.BranchCode || '',
            vat: dto.VatRate || 0,
            shortName: dto.ProviderShortName || '',
            site: dto.SiteCode || ''
        };
    }

    /** 
     * Map Logical Model (ProviderParking) back to API (DTO) 
     */
    public mapProviderParkingToDto(model: ProviderParking): ProviderParkingDto {
        return {
            Id: model.id,
            ProviderName: model.name,
            Address: model.address,
            Phone: model.phoneNumber,
            TaxNumber: model.taxId,
            BranchCode: model.branch,
            VatRate: model.vat,
            ProviderShortName: model.shortName,
            SiteCode: model.site
        };
    }
}
